// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common Tournament Tab Styles - Admin Theme */
.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 30px 30px 20px 30px;
  border-bottom: 1px solid #e5e7eb;
  background-color: white;
}

.tab-header > div h2 {
  margin: 0 0 8px 0;
  color: #1e293b;
  font-size: 24px;
  font-weight: 600;
}

.tab-header > div p {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}

.sync-players-btn {
  white-space: nowrap;
  min-width: 200px;
}

.sync-players-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Tournament Details Tab */
.tournament-details-tab,
.admin-tournament-details-tab {
  height: 100%;
}

.details-content {
  padding: 20px 30px 30px 30px;
  background-color: white;
}

.details-grid {
  display: grid;
  gap: 24px;
  margin-bottom: 30px;
}

.details-section {
  padding: 24px;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.details-section h3 {
  margin: 0 0 20px 0;
  color: #1e293b;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 8px;
}

.tournament-tabs-form-group {
  margin-bottom: 20px;
}

.tournament-tabs-form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.form-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
  background-color: white;
  color: #1e293b;
  transition: border-color 0.3s ease;
}

.form-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.form-textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  color: #1e293b;
  transition: border-color 0.3s ease;
}

.form-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.form-select:disabled {
  background-color: #f9fafb;
  color: #6b7280;
}

.form-help {
  display: block;
  margin-top: 4px;
  color: #6b7280;
  font-size: 12px;
}

.status-warning {
  background-color: var(--warning-bg, #fff3cd);
  color: var(--warning-text, #856404);
  padding: 12px;
  border-radius: 6px;
  border: 1px solid var(--warning-border, #ffeaa7);
  font-size: 14px;
  margin-top: 15px;
}

.details-actions {
  display: flex;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid var(--border-primary, #e9ecef);
}

.readonly-notice {
  background-color: var(--bg-tertiary, #f8f9fa);
  color: var(--text-secondary, #6c757d);
  padding: 20px;
  border-radius: 6px;
  text-align: center;
  margin-top: 20px;
  border: 1px solid var(--border-primary, #e9ecef);
}

/* Leaderboard Management */
.leaderboard-section {
  margin-top: 20px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.leaderboard-section h4 {
  margin: 0 0 12px 0;
  color: #212529;
  font-size: 16px;
  font-weight: 600;
}

.leaderboard-section p {
  margin: 0 0 16px 0;
  color: #6c757d;
  font-size: 14px;
  line-height: 1.4;
}

.leaderboard-buttons {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.test-broadcast-help {
  display: block;
  color: #6c757d;
  font-size: 12px;
  font-style: italic;
  margin-top: 8px;
}


/* Tournament Players Tab */
.tournament-players-tab,
.admin-tournament-players-tab {
  height: 100%;
}

.players-controls {
  padding: 20px 30px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.view-toggle {
  display: flex;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 4px;
}

.toggle-btn {
  background: none;
  border: none;
  padding: 10px 16px;
  cursor: pointer;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
  transition: all 0.2s ease;
}

.toggle-btn:hover:not(:disabled) {
  color: #495057;
}

.toggle-btn.active {
  background-color: white;
  color: #007bff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.toggle-btn:disabled {
  color: #adb5bd;
  cursor: not-allowed;
}

.toggle-count {
  background-color: #e5e7eb;
  color: #6b7280;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  margin-left: 8px;
  min-width: 20px;
  text-align: center;
  transition: all 0.3s ease;
}

.toggle-btn.active .toggle-count {
  background-color: white;
  color: #007bff;
  font-weight: 700;
}

.search-controls .search-input {
  min-width: 250px;
}

.players-content {
  padding: 30px;
}

.modification-notice {
  background-color: #fff3cd;
  color: #856404;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
}

.loading-state {
  text-align: center;
  padding: 60px;
  color: #6c757d;
  font-size: 16px;
}

.empty-state {
  text-align: center;
  padding: 60px 40px;
  color: #6c757d;
}

.empty-state h3 {
  margin: 0 0 12px 0;
  color: #495057;
}

.players-grid,
.golfers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.player-card,
.golfer-card {
  padding: 20px;
  transition: all 0.2s ease;
  cursor: default;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.golfer-card {
  cursor: pointer;
}

.golfer-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.golfer-card.selected {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
}

.player-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.player-info h4,
.golfer-info h4 {
  margin: 0 0 6px 0;
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
}

.player-details,
.golfer-details {
  color: #6b7280;
  font-size: 13px;
}

.player-details span,
.golfer-details span {
  margin-right: 12px;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.available {
  background-color: #dcfce7;
  color: #166534;
}

.status-badge.owned {
  background-color: #fee2e2;
  color: #dc2626;
}

.player-tier {
  margin: 12px 0;
}

.player-tier label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-right: 8px;
}

.tier-select {
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.tier-select:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.player-actions {
  margin-top: 15px;
  display: flex;
  gap: 8px;
}

.golfer-tier {
  background-color: #e9ecef;
  color: #495057;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  margin-top: 10px;
  display: inline-block;
}

.selected-golfer-panel {
  margin-bottom: 30px;
  padding: 24px;
  border: 2px solid #007bff;
  background-color: #f8f9ff;
}

.selected-golfer-panel h3 {
  margin: 0 0 15px 0;
  color: #007bff;
}

.tier-selection {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.tier-selection label {
  margin-right: 12px;
  font-weight: 600;
}

.add-actions {
  display: flex;
  gap: 12px;
}

/* Tournament Participants Tab */
.tournament-participants-tab,
.admin-tournament-participants-tab {
  height: 100%;
}

/* Admin-specific participants stats with light theme */
.admin-participants-stats {
  padding: 30px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f8fafc;
}

/* Legacy support - keep for backward compatibility */
.participants-stats {
  padding: 30px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  border-bottom: 1px solid #e9ecef;
}

/* Admin-specific stat cards with light theme */
.admin-stat-card {
  padding: 20px;
  text-align: center;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.admin-stat-value {
  font-size: 32px;
  font-weight: 700;
  color: #3b82f6;
  margin-bottom: 8px;
}

.admin-stat-label {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}

/* Legacy support - keep for backward compatibility */
.stat-card {
  padding: 20px;
  text-align: center;
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  color: #007bff;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
}

.participants-controls {
  padding: 20px 30px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.sort-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.sort-select {
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
}

.sort-order-btn {
  background: none;
  border: 1px solid #ced4da;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  color: #6c757d;
}

.sort-order-btn:hover {
  background-color: #f8f9fa;
}

/* Admin-specific participants controls with light theme */
.admin-participants-controls {
  padding: 20px 30px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  background-color: #f8fafc;
}

.admin-search-controls {
  flex: 1 1;
}

.admin-sort-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.admin-sort-select {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  color: #1e293b;
  transition: border-color 0.3s ease;
}

.admin-sort-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.admin-sort-order-btn {
  background: white;
  border: 1px solid #d1d5db;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  color: #6b7280;
  transition: all 0.3s ease;
}

.admin-sort-order-btn:hover {
  background-color: #f1f5f9;
  border-color: #3b82f6;
  color: #1e293b;
}

.participants-content {
  padding: 30px;
}

.participants-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Admin-specific participant cards with light theme */
.admin-participant-card {
  padding: 24px;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.admin-participant-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.admin-participant-info h4 {
  margin: 0 0 4px 0;
  color: #1e293b;
  font-size: 18px;
  font-weight: 600;
}

.admin-participant-email {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}

.admin-participant-stats-summary {
  display: flex;
  gap: 20px;
}

.admin-stat-item {
  text-align: center;
}

.admin-stat-number {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #3b82f6;
  margin-bottom: 2px;
}

.admin-stat-text {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  font-weight: 500;
}

.admin-participant-bets h5 {
  margin: 0 0 12px 0;
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
}

.admin-bets-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.admin-bet-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.admin-bet-player {
  font-weight: 600;
  color: #1e293b;
}

.admin-bet-tier {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.admin-tier-a {
  background-color: #fef2f2;
  color: #dc2626;
}

.admin-tier-b {
  background-color: #fef3c7;
  color: #d97706;
}

.admin-tier-c {
  background-color: #dbeafe;
  color: #2563eb;
}

.admin-tier-d {
  background-color: #f3f4f6;
  color: #6b7280;
}

.admin-bet-amount {
  font-weight: 600;
  color: #059669;
}

.admin-participant-timeline {
  margin: 16px 0;
  padding: 16px;
  background-color: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.admin-timeline-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}

.admin-timeline-item:last-child {
  margin-bottom: 0;
}

.admin-timeline-label {
  font-weight: 600;
  color: #374151;
}

.admin-timeline-date {
  color: #6b7280;
}

.admin-participant-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.admin-participants-content {
  padding: 30px;
}

.admin-participants-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.admin-loading-state {
  text-align: center;
  padding: 60px;
  color: #6b7280;
  font-size: 16px;
}

.admin-empty-state {
  text-align: center;
  padding: 60px 40px;
  color: #6b7280;
}

.admin-empty-state h3 {
  margin: 0 0 12px 0;
  color: #374151;
}

/* Legacy support - keep for backward compatibility */
.participant-card {
  padding: 24px;
}

.participant-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.participant-info h4 {
  margin: 0 0 4px 0;
  color: #212529;
  font-size: 18px;
  font-weight: 600;
}

.participant-email {
  margin: 0;
  color: #6c757d;
  font-size: 14px;
}

.participant-stats-summary {
  display: flex;
  gap: 20px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #007bff;
}

.stat-text {
  font-size: 12px;
  color: #6c757d;
  text-transform: uppercase;
  font-weight: 500;
}

.participant-bets {
  margin-bottom: 20px;
}

.participant-bets h5 {
  margin: 0 0 12px 0;
  color: #495057;
  font-size: 14px;
  font-weight: 600;
}

.bets-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.bet-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f8f9fa;
  padding: 8px 12px;
  border-radius: 6px;
}

.bet-player {
  font-weight: 500;
  color: #212529;
}

.bet-tier {
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 600;
  color: white;
}

.bet-tier.tier-a { background-color: #ff6b6b; }
.bet-tier.tier-b { background-color: #ffa500; }
.bet-tier.tier-c { background-color: #4dabf7; }
.bet-tier.tier-d { background-color: #51cf66; }

.bet-amount {
  font-weight: 600;
  color: #28a745;
}

.participant-timeline {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  font-size: 13px;
}

.timeline-item {
  display: flex;
  gap: 8px;
}

.timeline-label {
  color: #6c757d;
}

.timeline-date {
  color: #495057;
  font-weight: 500;
}

.participant-actions {
  display: flex;
  gap: 12px;
}

/* Tournament Settings Tab */
.tournament-settings-tab,
.admin-tournament-settings-tab {
  height: 100%;
}

.settings-content {
  padding: 20px 30px 30px 30px;
}

.settings-grid {
  display: grid;
  gap: 24px;
  margin-bottom: 30px;
}

.settings-section {
  padding: 24px;
}

.settings-section h3 {
  margin: 0 0 20px 0;
  color: #212529;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid #f8f9fa;
  padding-bottom: 8px;
}

.setting-group {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.setting-item {
  display: flex;
  flex-direction: column;
}

.setting-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.setting-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
}

.setting-label input[type="checkbox"] {
  margin: 0;
}

.setting-item > label:not(.setting-label) {
  font-weight: 600;
  color: #495057;
  margin-bottom: 6px;
  font-size: 14px;
}

.setting-description {
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
  margin-bottom: 0;
}

.setting-select {
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
}

.setting-select:disabled {
  background-color: #f8f9fa;
  color: #6c757d;
}

.settings-actions {
  display: flex;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}

/* Cache Management Styles */
.flush-cache-btn {
  background-color: #dc3545;
  color: white;
  border: 1px solid #dc3545;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.flush-cache-btn:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #bd2130;
}

.flush-cache-btn:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.65;
}

/* Responsive Design */
@media (max-width: 768px) {
  .tab-header {
    padding: 20px 20px 15px 20px;
  }

  .details-content,
  .players-content,
  .participants-content,
  .settings-content {
    padding: 20px;
  }

  .form-row,
  .setting-row {
    grid-template-columns: 1fr;
  }

  .players-controls,
  .participants-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }

  .view-toggle {
    justify-content: center;
  }

  .participants-stats {
    grid-template-columns: repeat(2, 1fr);
    padding: 20px;
  }

  .participant-header {
    flex-direction: column;
    gap: 15px;
  }

  .participant-stats-summary {
    justify-content: center;
  }

  .players-grid,
  .golfers-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .participants-stats {
    grid-template-columns: 1fr;
  }

  .participant-timeline {
    flex-direction: column;
    gap: 8px;
  }

  .bets-list {
    flex-direction: column;
  }

  .details-actions,
  .settings-actions {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/tournament/TournamentTabs.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;;EAEE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,aAAa;EACb,kBAAkB;EAClB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;;AAGA,2BAA2B;AAC3B;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,gCAAgC;AAChC;;EAEE,YAAY;AACd;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gCAAgC;AAClC;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,mBAAmB,yBAAyB,EAAE;AAC9C,mBAAmB,yBAAyB,EAAE;AAC9C,mBAAmB,yBAAyB,EAAE;AAC9C,mBAAmB,yBAAyB,EAAE;;AAE9C;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,4BAA4B;AAC5B;;EAEE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,4BAA4B;EAC9B;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;EACxB;AACF","sourcesContent":["/* Common Tournament Tab Styles - Admin Theme */\n.tab-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 30px 30px 20px 30px;\n  border-bottom: 1px solid #e5e7eb;\n  background-color: white;\n}\n\n.tab-header > div h2 {\n  margin: 0 0 8px 0;\n  color: #1e293b;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.tab-header > div p {\n  margin: 0;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.sync-players-btn {\n  white-space: nowrap;\n  min-width: 200px;\n}\n\n.sync-players-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Tournament Details Tab */\n.tournament-details-tab,\n.admin-tournament-details-tab {\n  height: 100%;\n}\n\n.details-content {\n  padding: 20px 30px 30px 30px;\n  background-color: white;\n}\n\n.details-grid {\n  display: grid;\n  gap: 24px;\n  margin-bottom: 30px;\n}\n\n.details-section {\n  padding: 24px;\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.details-section h3 {\n  margin: 0 0 20px 0;\n  color: #1e293b;\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: 2px solid #e5e7eb;\n  padding-bottom: 8px;\n}\n\n.tournament-tabs-form-group {\n  margin-bottom: 20px;\n}\n\n.tournament-tabs-form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.form-textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 80px;\n  background-color: white;\n  color: #1e293b;\n  transition: border-color 0.3s ease;\n}\n\n.form-textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.form-textarea:disabled {\n  background-color: #f9fafb;\n  color: #6b7280;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.form-select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  background-color: white;\n  color: #1e293b;\n  transition: border-color 0.3s ease;\n}\n\n.form-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.form-select:disabled {\n  background-color: #f9fafb;\n  color: #6b7280;\n}\n\n.form-help {\n  display: block;\n  margin-top: 4px;\n  color: #6b7280;\n  font-size: 12px;\n}\n\n.status-warning {\n  background-color: var(--warning-bg, #fff3cd);\n  color: var(--warning-text, #856404);\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid var(--warning-border, #ffeaa7);\n  font-size: 14px;\n  margin-top: 15px;\n}\n\n.details-actions {\n  display: flex;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-primary, #e9ecef);\n}\n\n.readonly-notice {\n  background-color: var(--bg-tertiary, #f8f9fa);\n  color: var(--text-secondary, #6c757d);\n  padding: 20px;\n  border-radius: 6px;\n  text-align: center;\n  margin-top: 20px;\n  border: 1px solid var(--border-primary, #e9ecef);\n}\n\n/* Leaderboard Management */\n.leaderboard-section {\n  margin-top: 20px;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.leaderboard-section h4 {\n  margin: 0 0 12px 0;\n  color: #212529;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.leaderboard-section p {\n  margin: 0 0 16px 0;\n  color: #6c757d;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.leaderboard-buttons {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.test-broadcast-help {\n  display: block;\n  color: #6c757d;\n  font-size: 12px;\n  font-style: italic;\n  margin-top: 8px;\n}\n\n\n/* Tournament Players Tab */\n.tournament-players-tab,\n.admin-tournament-players-tab {\n  height: 100%;\n}\n\n.players-controls {\n  padding: 20px 30px;\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.view-toggle {\n  display: flex;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 4px;\n}\n\n.toggle-btn {\n  background: none;\n  border: none;\n  padding: 10px 16px;\n  cursor: pointer;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6c757d;\n  transition: all 0.2s ease;\n}\n\n.toggle-btn:hover:not(:disabled) {\n  color: #495057;\n}\n\n.toggle-btn.active {\n  background-color: white;\n  color: #007bff;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.toggle-btn:disabled {\n  color: #adb5bd;\n  cursor: not-allowed;\n}\n\n.toggle-count {\n  background-color: #e5e7eb;\n  color: #6b7280;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  margin-left: 8px;\n  min-width: 20px;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.toggle-btn.active .toggle-count {\n  background-color: white;\n  color: #007bff;\n  font-weight: 700;\n}\n\n.search-controls .search-input {\n  min-width: 250px;\n}\n\n.players-content {\n  padding: 30px;\n}\n\n.modification-notice {\n  background-color: #fff3cd;\n  color: #856404;\n  padding: 12px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.loading-state {\n  text-align: center;\n  padding: 60px;\n  color: #6c757d;\n  font-size: 16px;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 40px;\n  color: #6c757d;\n}\n\n.empty-state h3 {\n  margin: 0 0 12px 0;\n  color: #495057;\n}\n\n.players-grid,\n.golfers-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.player-card,\n.golfer-card {\n  padding: 20px;\n  transition: all 0.2s ease;\n  cursor: default;\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.golfer-card {\n  cursor: pointer;\n}\n\n.golfer-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n}\n\n.golfer-card.selected {\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\n}\n\n.player-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 15px;\n}\n\n.player-info h4,\n.golfer-info h4 {\n  margin: 0 0 6px 0;\n  color: #1e293b;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.player-details,\n.golfer-details {\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.player-details span,\n.golfer-details span {\n  margin-right: 12px;\n}\n\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.available {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.status-badge.owned {\n  background-color: #fee2e2;\n  color: #dc2626;\n}\n\n.player-tier {\n  margin: 12px 0;\n}\n\n.player-tier label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin-right: 8px;\n}\n\n.tier-select {\n  border: none;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.tier-select:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.player-actions {\n  margin-top: 15px;\n  display: flex;\n  gap: 8px;\n}\n\n.golfer-tier {\n  background-color: #e9ecef;\n  color: #495057;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  margin-top: 10px;\n  display: inline-block;\n}\n\n.selected-golfer-panel {\n  margin-bottom: 30px;\n  padding: 24px;\n  border: 2px solid #007bff;\n  background-color: #f8f9ff;\n}\n\n.selected-golfer-panel h3 {\n  margin: 0 0 15px 0;\n  color: #007bff;\n}\n\n.tier-selection {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.tier-selection label {\n  margin-right: 12px;\n  font-weight: 600;\n}\n\n.add-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Tournament Participants Tab */\n.tournament-participants-tab,\n.admin-tournament-participants-tab {\n  height: 100%;\n}\n\n/* Admin-specific participants stats with light theme */\n.admin-participants-stats {\n  padding: 30px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  border-bottom: 1px solid #e5e7eb;\n  background-color: #f8fafc;\n}\n\n/* Legacy support - keep for backward compatibility */\n.participants-stats {\n  padding: 30px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n/* Admin-specific stat cards with light theme */\n.admin-stat-card {\n  padding: 20px;\n  text-align: center;\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.admin-stat-value {\n  font-size: 32px;\n  font-weight: 700;\n  color: #3b82f6;\n  margin-bottom: 8px;\n}\n\n.admin-stat-label {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n/* Legacy support - keep for backward compatibility */\n.stat-card {\n  padding: 20px;\n  text-align: center;\n}\n\n.stat-value {\n  font-size: 32px;\n  font-weight: 700;\n  color: #007bff;\n  margin-bottom: 8px;\n}\n\n.stat-label {\n  font-size: 14px;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n.participants-controls {\n  padding: 20px 30px;\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.sort-controls {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.sort-select {\n  padding: 8px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.sort-order-btn {\n  background: none;\n  border: 1px solid #ced4da;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  color: #6c757d;\n}\n\n.sort-order-btn:hover {\n  background-color: #f8f9fa;\n}\n\n/* Admin-specific participants controls with light theme */\n.admin-participants-controls {\n  padding: 20px 30px;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  background-color: #f8fafc;\n}\n\n.admin-search-controls {\n  flex: 1;\n}\n\n.admin-sort-controls {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.admin-sort-select {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  background-color: white;\n  color: #1e293b;\n  transition: border-color 0.3s ease;\n}\n\n.admin-sort-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.admin-sort-order-btn {\n  background: white;\n  border: 1px solid #d1d5db;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  color: #6b7280;\n  transition: all 0.3s ease;\n}\n\n.admin-sort-order-btn:hover {\n  background-color: #f1f5f9;\n  border-color: #3b82f6;\n  color: #1e293b;\n}\n\n.participants-content {\n  padding: 30px;\n}\n\n.participants-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Admin-specific participant cards with light theme */\n.admin-participant-card {\n  padding: 24px;\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.admin-participant-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.admin-participant-info h4 {\n  margin: 0 0 4px 0;\n  color: #1e293b;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.admin-participant-email {\n  margin: 0;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.admin-participant-stats-summary {\n  display: flex;\n  gap: 20px;\n}\n\n.admin-stat-item {\n  text-align: center;\n}\n\n.admin-stat-number {\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n  color: #3b82f6;\n  margin-bottom: 2px;\n}\n\n.admin-stat-text {\n  font-size: 12px;\n  color: #6b7280;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.admin-participant-bets h5 {\n  margin: 0 0 12px 0;\n  color: #1e293b;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.admin-bets-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.admin-bet-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background-color: #f8fafc;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n}\n\n.admin-bet-player {\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.admin-bet-tier {\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.admin-tier-a {\n  background-color: #fef2f2;\n  color: #dc2626;\n}\n\n.admin-tier-b {\n  background-color: #fef3c7;\n  color: #d97706;\n}\n\n.admin-tier-c {\n  background-color: #dbeafe;\n  color: #2563eb;\n}\n\n.admin-tier-d {\n  background-color: #f3f4f6;\n  color: #6b7280;\n}\n\n.admin-bet-amount {\n  font-weight: 600;\n  color: #059669;\n}\n\n.admin-participant-timeline {\n  margin: 16px 0;\n  padding: 16px;\n  background-color: #f8fafc;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n}\n\n.admin-timeline-item {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.admin-timeline-item:last-child {\n  margin-bottom: 0;\n}\n\n.admin-timeline-label {\n  font-weight: 600;\n  color: #374151;\n}\n\n.admin-timeline-date {\n  color: #6b7280;\n}\n\n.admin-participant-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.admin-participants-content {\n  padding: 30px;\n}\n\n.admin-participants-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.admin-loading-state {\n  text-align: center;\n  padding: 60px;\n  color: #6b7280;\n  font-size: 16px;\n}\n\n.admin-empty-state {\n  text-align: center;\n  padding: 60px 40px;\n  color: #6b7280;\n}\n\n.admin-empty-state h3 {\n  margin: 0 0 12px 0;\n  color: #374151;\n}\n\n/* Legacy support - keep for backward compatibility */\n.participant-card {\n  padding: 24px;\n}\n\n.participant-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.participant-info h4 {\n  margin: 0 0 4px 0;\n  color: #212529;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.participant-email {\n  margin: 0;\n  color: #6c757d;\n  font-size: 14px;\n}\n\n.participant-stats-summary {\n  display: flex;\n  gap: 20px;\n}\n\n.stat-item {\n  text-align: center;\n}\n\n.stat-number {\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n  color: #007bff;\n}\n\n.stat-text {\n  font-size: 12px;\n  color: #6c757d;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.participant-bets {\n  margin-bottom: 20px;\n}\n\n.participant-bets h5 {\n  margin: 0 0 12px 0;\n  color: #495057;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.bets-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.bet-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #f8f9fa;\n  padding: 8px 12px;\n  border-radius: 6px;\n}\n\n.bet-player {\n  font-weight: 500;\n  color: #212529;\n}\n\n.bet-tier {\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 11px;\n  font-weight: 600;\n  color: white;\n}\n\n.bet-tier.tier-a { background-color: #ff6b6b; }\n.bet-tier.tier-b { background-color: #ffa500; }\n.bet-tier.tier-c { background-color: #4dabf7; }\n.bet-tier.tier-d { background-color: #51cf66; }\n\n.bet-amount {\n  font-weight: 600;\n  color: #28a745;\n}\n\n.participant-timeline {\n  display: flex;\n  gap: 30px;\n  margin-bottom: 20px;\n  font-size: 13px;\n}\n\n.timeline-item {\n  display: flex;\n  gap: 8px;\n}\n\n.timeline-label {\n  color: #6c757d;\n}\n\n.timeline-date {\n  color: #495057;\n  font-weight: 500;\n}\n\n.participant-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Tournament Settings Tab */\n.tournament-settings-tab,\n.admin-tournament-settings-tab {\n  height: 100%;\n}\n\n.settings-content {\n  padding: 20px 30px 30px 30px;\n}\n\n.settings-grid {\n  display: grid;\n  gap: 24px;\n  margin-bottom: 30px;\n}\n\n.settings-section {\n  padding: 24px;\n}\n\n.settings-section h3 {\n  margin: 0 0 20px 0;\n  color: #212529;\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: 2px solid #f8f9fa;\n  padding-bottom: 8px;\n}\n\n.setting-group {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.setting-item {\n  display: flex;\n  flex-direction: column;\n}\n\n.setting-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.setting-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  color: #495057;\n  cursor: pointer;\n}\n\n.setting-label input[type=\"checkbox\"] {\n  margin: 0;\n}\n\n.setting-item > label:not(.setting-label) {\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 6px;\n  font-size: 14px;\n}\n\n.setting-description {\n  font-size: 12px;\n  color: #6c757d;\n  margin-top: 4px;\n  margin-bottom: 0;\n}\n\n.setting-select {\n  padding: 8px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 14px;\n  background-color: white;\n}\n\n.setting-select:disabled {\n  background-color: #f8f9fa;\n  color: #6c757d;\n}\n\n.settings-actions {\n  display: flex;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid #e9ecef;\n}\n\n/* Cache Management Styles */\n.flush-cache-btn {\n  background-color: #dc3545;\n  color: white;\n  border: 1px solid #dc3545;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.flush-cache-btn:hover:not(:disabled) {\n  background-color: #c82333;\n  border-color: #bd2130;\n}\n\n.flush-cache-btn:disabled {\n  background-color: #6c757d;\n  border-color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .tab-header {\n    padding: 20px 20px 15px 20px;\n  }\n\n  .details-content,\n  .players-content,\n  .participants-content,\n  .settings-content {\n    padding: 20px;\n  }\n\n  .form-row,\n  .setting-row {\n    grid-template-columns: 1fr;\n  }\n\n  .players-controls,\n  .participants-controls {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 15px;\n  }\n\n  .view-toggle {\n    justify-content: center;\n  }\n\n  .participants-stats {\n    grid-template-columns: repeat(2, 1fr);\n    padding: 20px;\n  }\n\n  .participant-header {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .participant-stats-summary {\n    justify-content: center;\n  }\n\n  .players-grid,\n  .golfers-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .participants-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .participant-timeline {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .bets-list {\n    flex-direction: column;\n  }\n\n  .details-actions,\n  .settings-actions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
